export default "__VITE_ASSET__BEj2VJxa__"